import React from 'react'
import {
  IField,
  TextRadioButtonField,
  validateFieldsEx,
} from '../../../../../shared/fields'
import { ApplicationModel } from '../../../../../models/ApplicationModel'
import { ApplicationTiers } from '../../../../../shared/Utility'
import Tier1 from './Tier1'
import Tier2 from './Tier2'
import Tier3 from './Tier3'

export interface Props {
    model: ApplicationModel
    onChange: { (changes: Partial<ApplicationModel>, callback?: { (): any }): any }
    markets: any[]
    marketRegions: string[] // CRM-Guids
    preview?: boolean
}

export interface State {

}

export default class Tiers extends React.Component<Props, State> implements IField {
  applicationTier: TextRadioButtonField
  tier1: Tier1
  tier2: Tier2
  tier3: Tier3

  constructor(props: Props) {
    super(props)

    const { model } = this.props

    this.state = {

    }

    this.onTierChange(model.applicationTier)
  }

  componentDidUpdate(prevProps: Props) {
    const { onChange, model } = this.props
    if (model.applicationTier !== prevProps.model.applicationTier) {
      onChange({
        hasEverExported: null,
        haveReceivedGrant: null,
        hasExportReadiness: null,
        dateOfMostRecentExport: null,
        expenseAreExpandingExportPromotion: null,
        marketsCodes: [],
      })
    }
  }

  onTierChange = (selectedTier: string) => {
    const { onChange } = this.props
    if (selectedTier === ApplicationTiers.Tier3) {
      onChange({ applicationTier: selectedTier })
    } else { // for Tier1 or Tier2, ensure strategicShiftType is RESET to null/empty
      onChange({ applicationTier: selectedTier, typeOfStrategicShift: null })
    }
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    validateFieldsEx(
      focus,
      callback,
      this.applicationTier,
      this.tier1,
      this.tier2,
      this.tier3,
    )
  }

  render() {
    const applicationTierDatasource = [
      { value: ApplicationTiers.Tier1, label: 'Tier 1' },
      { value: ApplicationTiers.Tier2, label: 'Tier 2' },
      { value: ApplicationTiers.Tier3, label: 'Tier 3' },
    ]

    const {
      model, onChange, markets, marketRegions, preview,
    } = this.props
    const tierSelected = !!model.applicationTier
    // put true for which ever tier you want to mimick for development purposes
    const tier1Selected = model.applicationTier === ApplicationTiers.Tier1 // true
    const tier2Selected = model.applicationTier === ApplicationTiers.Tier2 // false
    const tier3Selected = model.applicationTier === ApplicationTiers.Tier3// false
    const commonTierProps = {
      model,
      onChange,
      tierSelected,
      preview,
    }
    return (
      <>

        {preview && <h4>{`Tier ${tier1Selected ? '1' : ''} ${tier2Selected ? '2' : ''} ${tier3Selected ? '3' : ''} agreement`}</h4>}
        {(!tierSelected || tier1Selected) && <Tier1 {...commonTierProps} isSelected={tier1Selected} ref={(r) => { this.tier1 = r }} markets={markets} marketsRegions={marketRegions} onChange={this.props.onChange} />}
        {(!tierSelected || tier2Selected) && <Tier2 {...commonTierProps} isSelected={tier2Selected} ref={(r) => { this.tier2 = r }} markets={markets} marketsRegions={marketRegions} onChange={this.props.onChange} />}
        {(!tierSelected || tier3Selected) && <Tier3 {...commonTierProps} isSelected={tier3Selected} ref={(r) => { this.tier3 = r }} markets={markets} marketsRegions={marketRegions} onChange={this.props.onChange} />}
      </>
    )
  }
}
